define('modules/base/views/base.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    'select2'
], function(
    Prospector,
    $,_,Backbone,Marionette, Select2
){
    var BaseView = Marionette.LayoutView.extend({
        whiteLoaderClass: 'ripple_white_xl',
        isFirstLoad: true,
        mainBtnSelector: '.mainBtn',
        mainBtnLoaderClass: 'reload_white_green_20',
        mainBtnLoaderSpanSelector: '.mainBtn .loaderImage',
        mainBtnLoaderTextSelector: '.mainBtn .text',
        mainBtnLoaderRestingText: 'Save',
        mainBtnLoaderWorkingText: 'Saving',
        hasSelect2OnSave: false,
        hash: '',
        queue: 0,
        abortable: false,
        events:function() {
            var base = {
            };
            var click = {
                    'click .mainBtn': 'mainBtn',
                    'click .closeError': 'errOut',
                    'click .closeMsg'  : 'successOut'
                };
            $.extend(base,click);
            $.extend(base, this.mEvents());
            return base;
        },
        mEvents:function() {
            var base = {
            };
            return base;
        },
        debugName: 'Base View',
        initialize: function(options) {
            this.subviews = new Array();
            if(options!= undefined && options.parent != undefined){
                this.parent = options.parent;
            }
        },
        onRender: function() {
            this.$(this.mainBtnLoaderTextSelector).html(this.mainBtnLoaderRestingText);
        },
        errOut:function(msg){
            Prospector.trigger("createToast", 'Error: ' + msg);
        },
        successOut:function(msg){
            Prospector.trigger("createToast", msg);
        },
        messageOut:function(msg){
            Prospector.trigger("createToast", msg);
        },
        cleanMySubviews:function(subviews){
            var mSubviews = null;
            var clear = false;

            if(subviews == undefined){
                mSubviews = this.subviews;
                clear = true;
            } else{
                mSubviews = subviews;
            }
            if(mSubviews != undefined && mSubviews.length > 0){
                for(var i = 0; i < mSubviews; i++){
                    var sv = mSubviews[i];
                    if(sv.constructor === Array){
                        this.cleanMySubviews(sv);
                    } else {
                        sv.unbind();
                        sv.remove();
                    }
                }
            }
            if(clear){
                this.subviews = new Array();
            }
        },
        mainBtn:function(){
            if(this.hasSelect2OnSave){
                this.hasSelect2OnSave = false;
                window.setTimeout($.proxy(this.mainBtn,this), 500);
            } else {
                if(this.$(this.mainBtnSelector).attr('disabled') != 'disabled'){
                    this.addMainBtnLoader(this.mainBtnLoaderWorkingText);
                    this.procMainBtn();
                }
            }
        },
        addMainBtnLoader:function(text){
            this.addBtnLoader(this.mainBtnSelector, this.mainBtnLoaderTextSelector, this.mainBtnLoaderSpanSelector, this.mainBtnLoaderClass, text);
        },
        addBtnLoader:function(selector, textSelector, loaderSelector, loaderClass, text){
            this.$(textSelector).html(text);
            this.$(loaderSelector).addClass(loaderClass);
            this.$(selector).attr('disabled', 'disabled');
        },
        procMainBtn:function(){

        },
        mainBtnResponse:function(){
            if(this.$(this.mainBtnSelector).attr('disabled') == 'disabled'){
                this.removeMainBtnLoader();
                this.procMainBtnResponse();
            }
        },
        mainBtnErrOut:function(error){
            this.errOut(error);
            this.removeMainBtnLoader();
        },
        removeMainBtnLoader:function(){
            this.$(this.mainBtnLoaderTextSelector).html(this.mainBtnLoaderRestingText);
            this.$(this.mainBtnLoaderSpanSelector).removeClass(this.mainBtnLoaderClass);
            this.$(this.mainBtnSelector).removeAttr("disabled");
        },
        procMainBtnResponse:function(){

        },
        getURLHash:function(){
            return window.location.hash.split('?')[0];
        },
        inputToNumber:function(input){
            return isNaN($.trim(input.val())) || $.trim(this.$('#minRev').val()) == ""? 0 : parseInt($.trim(input.val()));
        },
        formatRevenue:function(attr) {
            attr = attr.toString();
            if (attr == "0") {
                return "Unknown";
            } else {

            }
            var len = attr.length;
            var bMin = 7, bMax = 9, bRemove = 4;
            var mMin = 4, mMax = 6, mRemove = 1;
            var tMin = 1, tMax = 3;
            if (len >= bMin && len <= bMax) {
                attr = attr.substring(0, len - bRemove);
                var whole = attr.substring(0, attr.length-2);
                var dec1 =  attr.substring(attr.length-2, attr.length-1);
                var dec2 =  attr.substring(attr.length-1, attr.length);
                var num = whole;
                if(dec1 != "0" || dec2 != "0"){
                    num += "." + dec1;
                    if(dec2 != "0"){
                        num += dec2;
                    }
                }
                return "$" + num + " Billion";
            }
            if (len >= mMin && len <= mMax) {
                attr = attr.substring(0, len - mRemove);
                var whole = attr.substring(0, attr.length-2);
                var dec1 =  attr.substring(attr.length-2, attr.length-1);
                var dec2 =  attr.substring(attr.length-1, attr.length);
                var num = whole;
                if(dec1 != "0" || dec2 != "0"){
                    num += "." + dec1;
                    if(dec2 != "0"){
                        num += dec2;
                    }
                }
                return "$" + num + " Million";
            }
            if (len >= tMin && len <= tMax) {
                return "$" + attr.substring(0, len) + " Thousand";
            } else {
                return attr + "";
            }
            return "";
        },
        buildSelect2:function(jQueryObj, options){
            this.hasSelect2OnSave = true;
            var that = this;
            var select2Options = {
                tags: true
            };
            if(options != undefined){
                $.extend(select2Options, options)
            }
            jQueryObj.select2(
                select2Options
            ).on('select2:closing', function(e){
                var value = "";
                if($('.select2-search__field').length > 1){
                    _.each($('.select2-search__field'), function(inp){
                        value += $(inp).val();
                    }, this);
                } else {
                    value = $('.select2-search__field').val();
                }
                if(value != ""){
                    var values = jQueryObj.val();
                    if(values == undefined){
                        values = new Array();
                    }
                    values.push(value);
                    jQueryObj.val(values).trigger("change");
                }
            });
        },
        buildMandatorySelect2:function(jQueryObj, options){
            this.hasSelect2OnSave = true;
            var that = this;
            var select2Options = {
                tags: true
            };
            if(options != undefined){
                $.extend(select2Options, options)
            }
            jQueryObj.select2(
                select2Options
            ).on('select2:selecting', function(e){
                var value = "";
                if($('.select2-search__field').length > 1){
                    _.each($('.select2-search__field'), function(inp){
                        value += $(inp).val();
                    }, this);
                } else {
                    value = $('.select2-search__field').val();
                }
                if(value != ""){
                    var add = _.any(e.currentTarget, function(option){
                        return $(option).val() == value && option.classList.length > 0;
                    }, this);
                    if(!add){
                        $(this).select2('close');
                        if(
                            e.params.originalEvent != undefined&&
                            e.params.originalEvent.type != undefined &&
                            e.params.originalEvent.type == "mouseup"
                        ){

                        } else if(e.params.args.data.text != undefined){

                        }else{
                            e.preventDefault();
                        }
                    }
                }
            });
        },
        buildMandatoryAjaxSelect2:function(jQueryObj, options){
            var that = this;
            var select2Options = {
                tags: true,
                ajax:{
                    headers: {
                        //"userToken" : window.utils.readCookie('token'),
                        "Content-Type" : "application/json"
                    },
                    contentType: "application/json; charset=utf-8",
                    dataType: 'json',
                    delay: 250,
                    type:'POST',
                    params:{
                        contentType: "application/json; charset=utf-8"
                    },
                    minimumInputLength: 2
                },
                createTag :function(term){
                    return  {id:undefined, text:undefined};
                }
            };
            if(options != undefined){
                $.extend(select2Options.ajax, options)
            }
            jQueryObj.select2(
                select2Options
            );
        },
        login:function () {
            Prospector.navigate("login", true);
        },
        onDestroy: function(){
            this.cleanMySubviews();
        },
        checkIfStringIsEmpty:function(str){
            return typeof str !== 'undefined' && str != "";
        }
    });
    return BaseView;
});

